import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
export class ProductInformations {
  constructor(element) {
    this.myAccordions = element.querySelectorAll('.js-accordion');
    this.seeMoreCharacteristics = document.querySelector('.w-main-characteristics__link');
    this.characteristicsAccordion = element.querySelector('.js-accordion.o-product-detail-informations__item');
  }
  initAccordion() {
    this.myAccordions.forEach(accordion => {
      new Accordion(accordion);
    });
    if (this.seeMoreCharacteristics) {
      this.seeMoreCharacteristics.addEventListener('click', () => {
        this.characteristicsAccordion.querySelector('.js-accordion__trigger').click();
        window.scrollTo({
          top: this.characteristicsAccordion.offsetTop,
          behavior: 'smooth'
        });
      });
    }
  }
}
export default ProductInformations;